import { Component, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { HelpIndex, Endpoint } from '../../../models/enums';
import { GenericColDef, GridRowSelectionType } from '../../../models/grid-context';
import { CommonService } from '../../../services/common/common.service';
import { RestService } from '../../../services/rest/rest.service';
import { BaseModalComponent } from '../../../models/base-modal-component';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { GenericGridComponent } from '../../generic-grid/generic-grid.component';
import { MountedConnectorMode } from '../../../models/connector';

@Component({
    standalone: false,
    selector: 'res-select-system-storage-depot-modal',
    templateUrl: './select-system-storage-depot-modal.component.html',
    styleUrls: ['./select-system-storage-depot-modal.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class SelectSystemStorageDepotModalComponent extends BaseModalComponent implements OnInit {
    @ViewChild('systemStorageDepotGrid', { static: true }) systemStorageDepotGrid: GenericGridComponent;

    // modal info
    modalTitle = 'Select System Storage for Depot';
    modalClass = 'select-system-storage-depot-modal-class';
    modalAutomationId = 'select-system-storage-depot-modal-automationId';
    modalHelpIndex = HelpIndex.sys_set_system_storage_depot_dlg;
    isCloseButtonDisabled = false;

    // grid info
    gridName = 'System Storage Depot';
    automationId = 'storage-system-depot-grid';
    isBusy = true;
    isBusyMessage = 'Loading System Storage Deport grid';
    rowSelection = GridRowSelectionType.single;

    systemStorageDepots = [];

    columnDefs = new Array<GenericColDef>(
        {
            headerName: 'Type',
            field: 'facilityType',
            automationId: this.automationId,
            width: 110,
            minWidth: 30
        },
        {
            headerName: 'Name',
            field: 'name',
            automationId: this.automationId,
            width: 200,
            minWidth: 30
        },
        {
            headerName: 'Path',
            field: 'export',
            automationId: this.automationId,
            minWidth: 30
        },
        {
            headerName: 'Storage Type',
            automationId: this.automationId,
            valueGetter: () => {
                return 'Document Storage';
            },
            width: 170,
            minWidth: 30
        }
    );

    constructor(private modalService: BsModalService,
        private commonService: CommonService,
        private modalRef: BsModalRef,
        private restService: RestService) {
        super(modalService, modalRef);
    }

    ngOnInit(): void {
        this.restService.post(Endpoint.realmManager_listRemoteNFSStorageAreas, { systemScope: true }).then(remoteNFSStorageAreas => {
            this.isBusy = false;
            remoteNFSStorageAreas.storageAreas.forEach(storageArea => {
                if (storageArea.storageAreaType === 'DOC_STORAGE') {
                    storageArea.isValid = false;
                    this.systemStorageDepots.push(storageArea);
                }
            });
            this.systemStorageDepotGrid.setData(this.systemStorageDepots);
        })
    }

    ok() {
        this.isBusy = true;
        this.isBusyMessage = 'Working on it ... ';
        this.isCloseButtonDisabled = true;
        const selectedRow = this.systemStorageDepotGrid.gridApi.getSelectedRows()[0];
        this.restService.post(Endpoint.realmManager_createSystemStorageDepot, {
            ipAddress: selectedRow.fqdn,
            storageFacilityId: selectedRow.handle,
            mountPoint: selectedRow.export,
            systemScope: true
        }).then(systemStorageDepotresponse => {
            this.isBusy = false;
            this.isCloseButtonDisabled = false;
            this.closeModal(true, systemStorageDepotresponse);
            this.restService.post(Endpoint.realmManager_updateVirusDefinitions, {
                enabled: true,
                frequency: 'DAILY',
                updateDefinitionFiles: false,
                systemScope: true
            });
        }, () => {
            this.isCloseButtonDisabled = false;
            this.isBusy = false;
            this.closeModal();
        });
    }

    okEnabled() {
        return !this.isBusy && this.systemStorageDepotGrid?.gridApi?.getSelectedRows().length > 0 && this.systemStorageDepotGrid?.gridApi?.getSelectedRows()[0]?.isValid;
    }

    validate() {
        if (this.systemStorageDepotGrid?.gridApi?.getSelectedRows().length > 0) {
            const selectedStorage = this.systemStorageDepotGrid?.gridApi?.getSelectedRows()[0];
            this.isBusy = true;
            this.isBusyMessage = 'Validating ... ';
            this.restService.post(Endpoint.connectorManager_validateNFSConnector, {
                mountedConnectorMode: selectedStorage.facilityType === 'PANFS_NAS' ? MountedConnectorMode.PANFS : MountedConnectorMode.CLASSIC,
                remoteHost: selectedStorage.fqdn,
                remotePath: selectedStorage.export,
                readOnly: selectedStorage.readOnly,
                systemScope: true
            }).then((validateReponse) => {
                selectedStorage.isValid = validateReponse ? validateReponse.valid : false;
                this.isBusy = false;
            }, () => {
                this.isBusy = false;
            })

        }
        this.isCloseButtonDisabled = false;
    }

    isValidateEnabled() {
        return !this.isBusy && this.systemStorageDepotGrid?.gridApi?.getSelectedRows().length > 0;
    }
}
